import React from 'react';
import ShortTests from '../shorts/Tests';
import ShortNews from '../shorts/News';
import { Helmet } from 'react-helmet-async';
import AdSlot from '../ads/AdSlot';

const PrivacyPolicy = () => {
  const pageTitle = 'Datenschutzerklärung | NGCTV';
  const pageDescription =
    'Datenschutzerklärung von NGCTV – Informationen zur Erhebung, Nutzung und Speicherung personenbezogener Daten.';

  return (
    <>
      {/* SEO / Head */}
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href={`https://ngctv.de/datenschutz`} />
      </Helmet>

      <main>
        <div className='wrapper'>
          <div className='rows'>
            <div className='row'>
              <div className='category'>Datenschutzerklärung</div>
              <div className="impressum">

                Ralf Glende, Erlenweg 13, 41372 Niederkrüchten betreibt das im Internet unter <br />
                "www.ngctv.de" abrufbare Internet-Portal. NGCTV nimmt den Datenschutz sehr ernst und <br />
                beachtet sämtliche anwendbare datenschutzrechtliche Bestimmungen. NGCTV wird alle <br />
                personenbezogenen Daten nur in Übereinstimmung mit dem jeweils geltenden <br />
                Datenschutzrecht erheben und nutzen, sofern Sie dazu Ihre Zustimmung gegeben haben <br />
                oder das Gesetz die Datenverarbeitung erlaubt.<br /><br />

                <h3>Hinweis zur Datenerhebung bei registrierungspflichtigen Diensten</h3>
                Manche der über NGCTV.de abrufbaren Dienste erfordern eine gesonderte Registrierung <br />der Nutzer. Derartige registrierungspflichtige Dienste sind beispielsweise Newsletter, <br />
                Gewinnspiele oder Votings. Im Zuge der Registrierung zu derartigen Diensten kann NGCTV  <br />
                um die Angabe weiterer personenbezogener Daten bitten, um dem Nutzer den jeweiligen <br />
                Dienst zur Verfügung zu stellen (Bsp.: E-Mail-Adresse bei Newslettern). Jenseits dessen <br />
                werden darüber hinausgehende, vom Nutzer unterbreitete personenbezogene Daten nur <br />
                verwendet, wenn und soweit der Nutzer darin eingewilligt hat oder eine gesetzliche <br />
                Erlaubnis für die Nutzung besteht. <br /><br />

                Über den Umfang einer etwaig zu erteilenden Einwilligung wird der Nutzer im <br />
                Zusammenhang mit der Registrierung für den jeweiligen Dienst transparent in Kenntnis <br />
                gesetzt. NGCTV.de wird Ihre Einwilligung protokollieren. Sollten Sie Ihre Zustimmung nicht <br />
                geben, bitten wir im Einzelfall um Verständnis, dass Sie an dem jeweiligen Dienst ggf. nicht <br />
                teilnehmen können. <br /> <br />

                Wenn Sie sich für unseren Newsletter anmelden, speichern und benutzen wir Ihre Email-<br />
                Adresse zu dem Zweck, Ihnen den Newsletter zuzusenden. Der Newsletter enthält <br />
                redaktionelle Beiträge, kann daneben aber auch Werbung für weitere Dienstleistungen und <br />
                Produkte von NGCTV enthalten.<br />
                <br />

              </div>
            </div>
            <div className='row'>
              <ShortTests />
              <ShortNews />
              <AdSlot slot="2119524913" />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default PrivacyPolicy;
